// `price-cents` is an integer in minor currency units — 999 is $9.99. There is no
// in-house currency formatter in this app (elsewhere it's just `$` + toFixed(2)),
// so this uses the platform's own Intl formatter rather than inventing one.
export const formatPrice = (cents, currency = 'USD') => {
  const amount = (Number(cents) || 0) / 100;
  try {
    // `undefined` would default to the runtime's own locale — in a `small-icu`
    // Node build that can resolve to a non-US English locale and print "US$9.99"
    // instead of "$9.99". The rest of the app already assumes a US audience
    // (every other price display here is a hardcoded `$`), so this pins the
    // locale rather than letting the environment pick it.
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount);
  } catch (err) {
    return `$${amount.toFixed(2)}`;
  }
};
